<!-- @format -->
<template>
  <mq-layout :mq="['sm', 'md']">
    <div class="mobile-index" id="mobile-index">
      <img src="@/assets/images/mobile/top.jpg" alt="" />
    </div>
    <div class="kinostart" v-html="kinostart"></div>
  </mq-layout>
</template>

<script>
export default {
  inject: ['kinostart'],
}
</script>

<style lang="scss">
.no-scroll {
  overflow: hidden;
  height: 100vh;
  scrollbar-width: 0;
  z-index: 0;
}
.fullScreen {
  height: 100vh;
  z-index: 0;
}
.mobile-index {
  z-index: -20;
  $self: &;
  position: relative;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.kinostart {
  padding-block: 0.2em;
  text-align: center;
  background: var(--clr-red);
  font-size: clamp(1.5rem, 6vw, 4rem);
  font-weight: 900;
  color: white;
  text-transform: uppercase;
}
</style>
